export const GET_WALLET_UPDATE = 'GET_WALLET_UPDATE'

export const GET_WALLET_SUCCESS = 'GET_WALLET_SUCCESS'

export const GET_WALLET_FAIL = 'GET_WALLET_FAIL'